<template>
    <div
        class="collapes-block-container"
        :style="{
            width: isCollapes ? width + 'px' : '36px',
            height: '100%'
        }"
    >
        <div class="collapes-wrap" v-show="isCollapes">
            <slot></slot>
        </div>
        <div
            class="collapes-btn"
            :style="{ right: right + 'px' }"
            v-show="canCollapes"
        >
            <div @click="handleCollapes" class="btn-wrap">
                <i
                    :class="[
                        { 'el-icon-d-arrow-left': isCollapes },
                        { 'el-icon-d-arrow-right': !isCollapes }
                    ]"
                ></i>
            </div>
            <div class="collapes-title" v-show="!isCollapes">
                <span class="split-line"></span>
                <div class="title">{{ treeTitle }}</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            winHeight: 0
        };
    },
    props: {
        canCollapes: {
            // 是否可以收缩
            type: Boolean,
            default: false
        },
        isCollapes: {
            // 展开收起状态  true 展开  false 收起
            type: Boolean,
            default: true
        },
        right: {
            type: Number,
            default: 0
        },
        width: {
            // 树容器宽度
            type: Number,
            default: 280
        },
        treeTitle: {
            // 数组件title
            type: String
        }
    },
    created() {
        if (window.innerHeight) this.winHeight = window.innerHeight;
        else if (document.body && document.body.clientHeight)
            this.winHeight = document.body.clientHeight;
        // console.log(this.winHeight);
    },
    methods: {
        handleCollapes() {
            this.isCollapes = !this.isCollapes;
            this.$emit("collapesCb", this.isCollapes);
        }
    }
};
</script>
<style lang="scss">
.collapes-block-container {
    z-index: 0;
    position: relative;
    height: calc(98% - 5px);
    // min-height: 500px;
    overflow: hidden;
    transition: width 500ms;
    // margin-right: 20px;
    // margin-top: 5px;
    margin: 0 30px;
    border-radius: 5px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    .collapes-wrap {
        width: 100%;
        height: 100%;
    }
    .collapes-btn {
        position: absolute;
        top: 0px;
        right: 0px;
        font-size: 18px;
        width: 36px;
        height: 2rem;
        border-radius: 5px;
        text-align: center;
        .btn-wrap {
            margin-top: 0rem;
            i {
                color: #56fcff;
                font-weight: bold;
            }
        }
        .collapes-title {
            span {
                display: block;
                width: 16px;
                height: 4px;
                border-radius: 2px;
                background: #56fcff !important;
                margin: 0 auto;
                margin-top: 12px;
                margin-bottom: 8px;
            }
            .title {
                text-indent: 0px;
                color: #fff;
                width: 20px;
                line-height: 20px;
                margin: 0 auto;
                font-size: 16px;
                border-bottom: 0px;
            }
        }
    }
}
</style>
